import { Link } from "react-router-dom";
function Chemistrylab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">Chemistry Lab</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Chemistry Lab </h1>
            <p>
              The Chemistry Lab at The Frank Anthony Junior School, Bangalore,
              is a fully equipped laboratory where students can explore the
              world of chemical science through experiments and practical
              learning. The lab contains modern apparatus, chemicals, and safety
              equipment, enabling students to perform experiments in organic,
              inorganic, and physical chemistry. Guided by experienced teachers,
              students learn to observe, analyze, and understand chemical
              reactions, improving their scientific thinking and problem-solving
              skills.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C1.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C2.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C3.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C4.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C5.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/C6.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Chemistrylab;
